import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import { useTranslation } from 'react-i18next';
import useFetchCauseCategories from '../../hooks/fetchCauseCategories';
import { Space, Button as BTN, Upload, Switch, Select, DatePicker, Form, Input, message } from 'antd';
import { LeftCircleOutlined, LoadingOutlined, UploadOutlined, PlusOutlined } from '@ant-design/icons';
import useFetchOrganizations from '../../hooks/fetchOrganizations';
import { app } from '../../config';
import moment from 'moment';
import getOrgAdById from '../../hooks/getOrgAdById';
import getAdmAdById from '../../hooks/getAdmAdById';
import { getTokenfromUserObj } from '../../utils/getTokenfromObj';

const { TextArea } = Input;
const getBase64 = (img, callback) => {
  const reader = new FileReader();
  reader.addEventListener('load', () => callback(reader.result));
  reader.readAsDataURL(img);
};

const EditAdminAd = () => {
  const { t } = useTranslation(['common']);
  const [uploadObj, setUploadObj] = useState({});
  const [addUserResp, setAddUserResp] = useState({});
  const [show, setShow] = useState(false);
  const [uploadedImg, setUploadedImg] = useState('');
  const [contentType, setContentType] = useState('');
  const [loading, setLoading] = useState(false);
  const [imageUrl, setImageUrl] = useState()
  const [largeFile, setLargeFile] = useState(false);
  let user = JSON.parse(localStorage.getItem('user'));
  let adId = JSON.parse(localStorage.getItem('admAdId'));
  let navigate = useNavigate();
  const adResp = getAdmAdById(adId);
  const orgAdObj = adResp.response ? adResp.response.data : null;
  const orgResp = useFetchOrganizations();
  const orgs = orgResp.response ? orgResp.response.data : [];
  console.log(orgs);
  const token=getTokenfromUserObj();
  const headers={auth:token}
  const beforeUpload = (file) => {
    console.log(file);
    if (file.type === 'image/jpeg' ||file.type ===  'image/png') setContentType('img');
    else if (file.type === 'video/x-matroska' ||file.type ===  'video/mp4') setContentType('video');
    const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png' || file.type === 'video/x-matroska' || file.type === 'video/mp4';
    if (!isJpgOrPng) {
      message.error('You can only upload JPG/PNG file!');
    }
    console.log('file Checked');
    const isLt2M = file.size / 1024 / 1024 < 20;
    if (!isLt2M) {
      setLargeFile(true);
      message.error('Image must smaller than 20MB!');
    }
    console.log('message');
    return isJpgOrPng && isLt2M;
  };
  const handleChange = (info) => {
    if (info.file.status === 'uploading') {
      console.log('uploading data');
      setLoading(true);
      return;
    }
    if (info.file.status === 'done') {
      // Get this url from response in real world.
      setLargeFile(false);
      info.file ? console.log(info.file.response.location) : ' ';
      info.file ? setUploadedImg(info.file.response.data.Location) : console.log('Uploaded image not saved');
      getBase64(info.file.originFileObj, (url) => {
        setLoading(false);
        setImageUrl(url);
      });
    }
  };
  const uploadButton = (
    <div>
      {loading ? <LoadingOutlined /> : <PlusOutlined />}
      <div
        style={{
          marginTop: 8,
        }}
      >
        Upload
      </div>
    </div>
  );
      
  const uploadData = async (uploadObj) => {
    try {
      console.log(uploadObj);
      const res = await axios.post(`${app.URL}/adminad/update/${adId}`, uploadObj,{headers: {auth:token}});
      if (res.data.statusCode === 200) {
        setAddUserResp(res.data);
        setTimeout(() => {
          user.userType === 'A' ? navigate('/adminads/view') : navigate('/advertisement/view');
        }, 1000);
      }
    } catch (err) {
      console.log(err);
    }
  };

  const onFinish = (values) => {
    console.log('Success:', values);
    if (user.userType === 'A') {
      setUploadObj({
        name: values.name ? values.name : orgAdObj.name,
        contentType: uploadedImg ? contentType : orgAdObj.contentType,
        url: uploadedImg ? uploadedImg : orgAdObj.url,
        isActive: values.isActive === true ? 1 : 0,
        updatedByUserId: user.userId,
      });
    }
    setShow(true);
  };

  console.log(uploadObj);
  console.log(largeFile);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const submitData = () => {
    console.log('calling');
    if (largeFile === false && Object.keys(uploadObj).length > 0) {
      console.log('uploading function ');
      uploadData(uploadObj);
    }
  };
  const onFinishFailed = (errorInfo) => {
    console.log('Failed:', errorInfo);
  };
  function goBack() {
    navigate('/adminads/view',{replace:true});
   }
   window.addEventListener('popstate', goBack);
  const renderList = []; //For testing purposes
  return (
    <div class='row mt-4 w-75 tbl'>
      <div class='row topbar ' style={{ height: '70px' }}>
        <div class='col-lg-4 fs-3 fw-bold'>
          {' '}
          <LeftCircleOutlined
            onClick={() =>user.userType==="A"?navigate('/adminads/view'):navigate('/advertisement/view')}
            className='mt-3 ml-4 back-icon'
            style={{ fontSize: '38px' }}
          />
        </div>
        <div class='col-lg-7 fs-3 fw-bold '>
          <h2 class=' mb-5 mt-4 fw-bold text-white fs-4 ml-4'> {t('Update Admin Ad.')} </h2>
        </div>{' '}
      </div>
      <div class='col-lg-11 mb-5 mt-4 '>
        <div class='col-lg-9 align-self-center mt-2 mb-4'>
        {adResp.response ? (
            <Form
              name='basic'
              labelCol={{
                span: 8,
              }}
              wrapperCol={{
                span: 16,
              }}
              style={{
                maxWidth: 600,
              }}
              initialValues={{
                remember: true,
                ['name']: orgAdObj.name,
                ['organizationId']: orgAdObj.organizationId,
                ['isActive']: orgAdObj.isActive === 1 ? true : false,
              }}
              onFinish={onFinish}
              onFinishFailed={onFinishFailed}
              autoComplete='off'
            >
           

              <Form.Item
                colon={false}
                label='Title'
                name='name'
                rules={[
                  {
                    required: true,
                    message: 'Enter Ad. Title',
                  },
                ]}
              >
                <Input placeholder='Enter Title' />
              </Form.Item>

              <Form.Item label='Image' colon={false} name='image'>
                <Space
                  direction='vertical'
                  style={{
                    width: '100%',
                  }}
                  size='large'
                >
                  <Upload   
                    listType='picture'
                    maxCount={1}
      
                    className='avatar-uploader'

                    action={`${app.URL}/upload/adminadd`}

                    // action={`${app.URL}/api/upload/adminadd`}

                    headers={headers}
                    beforeUpload={beforeUpload}
                    onChange={handleChange}
                  >
                    {orgAdObj.url ? (
                      orgAdObj.contentType === 'img' ? (
                        <img
                          src={orgAdObj.url}
                          alt='unable to load'
                          style={{
                            width: '50%',
                          }}
                        />
                      ) : orgAdObj.contentType === 'video' ? (
                        <video
                          src={orgAdObj.url}
                          style={{
                            width: '90%',
                          }}
                          controls
                        >
                          Your browser does not support the video tag.
                        </video>
                      ) : (
                        ' '
                      )
                    ) : (
                      <BTN icon={<UploadOutlined />} className={'upload-btn'} style={{ color: 'black' }}>
                        Upload
                      </BTN>
                    )}
                  </Upload>
                </Space>
              </Form.Item>

              <Form.Item label='Active' colon={false} valuePropName='checked' name='isActive'>
                <Switch />
              </Form.Item>
              <Form.Item
                colon={false}
                wrapperCol={{
                  offset: 8,
                  span: 16,
                }}
              >
                    {addUserResp.statusCode === 200 ? (
                  <Modal show={show} onHide={handleClose}>
                    <Modal.Header closeButton>
                      <Modal.Title className='text-center'>Success</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>{addUserResp.message}</Modal.Body>
                    <Modal.Footer></Modal.Footer>
                  </Modal>
                ) : addUserResp.statusCode === 400 ? (
                  <Modal show={show} onHide={handleClose}>
                    <Modal.Header closeButton>
                      <Modal.Title className='text-center'>Failed</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>{addUserResp.data.message}</Modal.Body>
                    <Modal.Footer></Modal.Footer>
                  </Modal>
                ) : (
                  <Modal show={show} onHide={handleClose}>
                    <Modal.Header closeButton>
                      <Modal.Title>Confirmation</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>Are you sure you want to add Advertisement?</Modal.Body>
                    <Modal.Footer>
                      <Button variant='secondary' onClick={handleClose}>
                        Cancel
                      </Button>
                      <Button variant='primary' htmlType='submit' onClick={submitData}>
                        Save Changes
                      </Button>
                    </Modal.Footer>
                  </Modal>
                )}
                <button type='primary' class='btn btn-primary button' htmlType='submit'>
                  Update
                </button>
                {/* <Button type="primary" htmlType="submit">
  Submit
</Button> */}
              </Form.Item>
            </Form>
          ) : (
            ' '
          )}
        </div>
      </div>
    </div>
  );
};

export default EditAdminAd;
